import axios from 'axios';

const { REACT_APP_AI_HOST } = process.env;

const SingleIndexRatingLoadAPI = stock_code => {
	return axios.get(
		`${REACT_APP_AI_HOST}/api/ai/reports?stock=${stock_code}&ai_model=gpt-4.1-mini`,
		{
			headers: {
				Accept: 'application/json',
			},
		}
	);
};

export default { SingleIndexRatingLoadAPI };
